export default __webpack_public_path__ + "static/media/lectureNotesIcon.0af48bc2.svg";